import {useStores} from '@src/components/store';
import {observer} from 'mobx-react-lite';
import {useDomainsCrudConfig} from './domains-crud-config';
import {InteractiveDataTable} from '@src/components/shared/interactive-data-table/interactive-data-table';
import {useDomainsColumns} from './domains-columns-config';
import {EmptyState} from '@src/components/shared/empty-state/empty-state';
import {IconType} from '@src/components/shared/custom-icon/custom-icon';
import {domainsFiltersConfig} from './domains-filters';
import './domains.scss';
import {ApplyBronzeButton} from '../apply-bronze-button';
import {BronzeTabName} from '@src/dtos/analytics.dto';
import {DeactivateVersion} from '@src/components/shared/deactivate-version/deactivate-version';
import MoreIcon from '@svg/more.svg?react';
import {InactiveDnsProtectionAlert} from '@src/components/bronze/inactive-dns-protection-alert';

export const Domains = observer(() => {
    const { fwVersionBronzeStore, customerStore } = useStores();
    const { selectedVersionDomains, isLoading } = fwVersionBronzeStore;
    const crudConfig = useDomainsCrudConfig();
    const columnsConfig = useDomainsColumns();

    return (
        <div className="bronze-domains" data-testid="domains">
            <InactiveDnsProtectionAlert />
            <InteractiveDataTable filterConfig={domainsFiltersConfig}
                                  data={selectedVersionDomains}
                                  columnsConfig={columnsConfig}
                                  crudConfig={crudConfig}
                                  emptyStateComp={
                                      <EmptyState
                                          iconType={IconType.AllowEmptyState}
                                          subTitle="To add new item click"
                                          secondarySubTitle=" Add Domain"
                                      />}
                                  dataHasLoaded={!!selectedVersionDomains}
                                  isLoading={isLoading}>
                <ApplyBronzeButton standardApplyType={BronzeTabName.DOMAINS}/>
                {customerStore.isAvailable && !fwVersionBronzeStore.isPendingVersion
                    && <DeactivateVersion protectionType={'DNS_PROTECTION'} popoverIcon={<MoreIcon/>} />}
            </InteractiveDataTable>
        </div>
    );
});
